import { apiUrl } from '../config';
import { fetch } from '../utils/http';

export function clientsFetchStart() {
    return {
        type : 'CLIENTS_FETCH_START'
    }
}

export function clientsFetchSuccess(data) {
    return {
        type : 'CLIENTS_FETCH_SUCCESS',
        data,
    }
}

export function clientsFetchFailure(error) {
    return {
        type : 'CLIENTS_FETCH_FAILURE',
        error
    }
}

export function fetchClients(page) {
    return function(dispatch) {
        dispatch(clientsFetchStart());
        const url = `${apiUrl()}/clients`;
        fetch(url, {
            queryParams : {
                page : page
            }
        })
            .then(response => response.json())
            .then(data => dispatch(clientsFetchSuccess(data)))
            .catch(error => dispatch(clientsFetchFailure(error)));
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/clients.js
 **/